module.exports = __webpack_public_path__ + "static/media/spade.a50c5f85.svg";